<template>
    <div style="transition: all 0.2s;" ref="interaction" @touchstart="touchStart" @touchend="touchEnd">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'InteractionOfBtnBackgroundColor',
    props: {
        changeColor: {
            type: String,
            default: ''
        },
        originColor: {
            type: String,
            default: ''
        },
        curType: {
            type: String,
            default: ''
        },
        btnType: {
            type: String,
            default: ''
        },
        completeColor: {
            type: String,
            default: ''
        },
        isStopInteraction: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            touchTimer: null
        }
    },
    methods: {
        // 즉시 인터랙션 적용X => 0.2초뒤에 인터랙션 적용
        // touchStart() {
        //     this.touchTimer = setTimeout(() => {
        //         if (this.$refs.interaction) {
        //             this.$refs.interaction.style.scale = '0.98';
        //         }
        //     }, 200);
        // },
        // touchEnd() {
        //     clearTimeout(this.touchTimer);
        //     if (this.$refs.interaction) {
        //         this.$refs.interaction.style.scale = '1';
        //     }
        // }
        touchStart() {
            if (this.curType === this.btnType || this.isStopInteraction) {
                return
            }
            this.$refs.interaction.style.backgroundColor = this.changeColor
        },
        touchEnd() {
            if (this.curType === this.btnType || this.isStopInteraction) {
                return
            }
            this.$refs.interaction.style.backgroundColor = this.originColor
        }
    },
    watch: {
        curType(newVal) {
            if (newVal === this.btnType) {
                this.$refs.interaction.style.backgroundColor = this.completeColor
            } else {
                this.$refs.interaction.style.backgroundColor = this.originColor
            }
        }
    },
    created() {
        this.$nextTick(() => {
            if (this.curType === this.btnType) {
                this.$refs.interaction.style.backgroundColor = this.completeColor
            } else {
                this.$refs.interaction.style.backgroundColor = this.originColor
            }
        })
    }
}
</script>

<style scoped></style>